module.exports = __webpack_public_path__ + "static/media/bg_kc_1.e1f29f45.jpg";